import { HttpClient } from './http-client';
import { Observable } from 'rxjs';
import ClassifierValue from '../interfaces/classifierValue';
import Classifier from '../enums/classifier';
import ClassifierGroup from '../enums/classifier-group';

export class FinanceModelingService extends HttpClient {
  warehouseClassifiers(
    farmId: string,
    type: Classifier
  ): Observable<ClassifierValue[]> {
    const url =
      type === Classifier.CROP_PRODUCTION_MODELS
        ? `/api/classifier-groups/${ClassifierGroup.WAREHOUSE}/classifiers/${Classifier.CROP_GROUPS}/values`
        : `/api/classifier-groups/${ClassifierGroup.LIVESTOCK}/classifiers/${Classifier.LIVESTOCK_SECTORS}/values`;

    return this.get<ClassifierValue[]>(url);
  }

  financeClassifiers(
    farmId: string,
    type: Classifier
  ): Observable<ClassifierValue[]> {
    return this.get<ClassifierValue[]>(
      `/api/classifier-groups/${ClassifierGroup.FINANCE}/classifiers/${type}/values`
    );
  }
}
